import { use } from "react";
import Endpoints from "../endpoints";
import SessionStorageUtilities from "../Utilities/SessionStorageUtilities";

/**
 * @property {string} tenant
 * @property {string} uid
 * @property {string} displayName
 * @property {string} photoUrl
 * @property {string} email
 * @property {string} lastLoginAt
 * @property {string} createdAt
 * @property {Object} usuario
 * @property {string} usuario.nombre
 * @property {number} usuario.cerroSesion
 * @property {(Object|null)} usuario.conexiones
 * @property {string} usuario.grupo
 * @property {string} usuario.emailreal
 * @property {string} usuario.idEmpleado
 * @property {string} usuario.idPromotor
 * @property {string} usuario.photoURL
 * @property {number} usuario.rol
 */
export default class Agente {
  static USER = "usuario";

  static TENANT_BANREGIO = "banregio";
  static TENANT_HEY_BANCO = "heybanco";
  static TENANT_HEY_RESEARCH = "heyresearch";
  static TENANT_HEY_SHOP = "heyshop";
  static TENANT_HEY_SOLUCIONES = "heysoluciones";
  static TENANT_NEXO = "nexo";
  static TENANT_INMUEBLES = "inmuebles";
  static TENANT_PRIME = "inmuebles";
  static TENANT_COBRANZA = "cobranza";
  static TENANT_BANREGIO_PAGO = "banregiopago";
  static TENANT_HEY_PAGO = "heypago";
  /**
   *
   * @returns {(string)[]}
   */
  static GET_TENANTS = () => {
    return [
      Agente.TENANT_BANREGIO,
      Agente.TENANT_HEY_BANCO,
      Agente.TENANT_HEY_RESEARCH,
      Agente.TENANT_HEY_SHOP,
      Agente.TENANT_HEY_SOLUCIONES,
      Agente.TENANT_NEXO,
      Agente.TENANT_INMUEBLES,
      Agente.TENANT_PRIME,
      Agente.TENANT_COBRANZA,
      Agente.TENANT_BANREGIO_PAGO,
      Agente.TENANT_HEY_PAGO,
    ];
  };

  static RULE_CAN_SEARCH_CONTACT = "SEARCH_CONTACT";
  static RULE_CAN_SEND_INDIVIDUAL_TEMPLATES = "SEND_INDIVIDUAL_TEMPLATES";
  static RULE_CAN_OPEN_BROADCAST = "OPEN_BROADCAST";
  static RULE_CAN_OPEN_DIRECTORY = "OPEN_DIRECTORY";
  static RULE_CAN_TRANSFER_CONVERSATION = "TRANSFER_CONVERSATION";
  static RULE_CAN_SEND_DOCS_UNREVIEWED = "SEND_DOCS_UNREVIEWED";
  static RULE_CAN_SEARCH_CLIENT = "SEARCH_CLIENT";

  /**
   *
   * @returns {[string, string, string, string]}
   */
  static GET_RULES = () => {
    return [
      Agente.RULE_CAN_SEARCH_CONTACT,
      Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES,
      Agente.RULE_CAN_OPEN_BROADCAST,
      Agente.RULE_CAN_OPEN_DIRECTORY,
      Agente.RULE_CAN_TRANSFER_CONVERSATION,
      Agente.RULE_CAN_SEND_DOCS_UNREVIEWED,
    ];
  };

  static ROLE_AGENTE_CALL_CENTER = 1;
  static ROLE_ANALISTA_SEGURIDAD_LOGICA = 2;
  static ROLE_SUPERVISOR_CALL_CENTER = 3;
  static ROLE_MONITOR = 4;

  /**
   *
   * @returns {[number, number, number, number]}
   */
  static GET_ROLES = () => {
    return [
      Agente.ROLE_AGENTE_CALL_CENTER,
      Agente.ROLE_ANALISTA_SEGURIDAD_LOGICA,
      Agente.ROLE_SUPERVISOR_CALL_CENTER,
      Agente.ROLE_MONITOR,
    ];
  };

  static GROUP_VENTAS_DIGITALES = "ventas-digitales";
  static GROUP_COBRANZA_NEGOCIO = "cobranza-negocio";
  static GROUP_COBRANZA_TDC = "cobranza-tdc";
  static GROUP_CONCIERGE = "concierge";
  static GROUP_COBRANZA_CONSUMO = "cobranza-consumo";
  static GROUP_COBRANZA_REESTRUCTURAS = "cobranza-reestructuras";
  static GROUP_COBRANZA_AUTO = "cobranza-auto";
  static GROUP_COBRANZA_JURIDICO = "cobranza-juridico";
  static GROUP_LIDER_DE_EXPERIENCIA = "lxp";
  static GROUP_LIDER_DE_EXPERIENCIA_CENTRAL = "lxp-central";
  static GROUP_AUTOMOTRIZ = "hey-automotriz";
  static GROUP_COBRANZA = "cobranza";
  static GROUP_INMUEBLES = "inmuebles";
  static GROUP_TESORERIA = "tesoreria";
  static GROUP_AUTO_PF_NORTE = "auto-pf-norte";
  static GROUP_AUTO_PF_CENTRO = "auto-pf-centro";
  static GROUP_AUTO_PF_OCCIDENTE = "auto-pf-occidente";
  static GROUP_AUTO_PF_NOROESTE = "auto-pf-noroeste";
  static GROUP_ASESORES_PAGO = "asesores-pago";

  /**
   *
   * @returns {(string)[]}
   */
  static GET_GROUPS = () => {
    return [
      Agente.GROUP_VENTAS_DIGITALES,
      Agente.GROUP_LIDER_DE_EXPERIENCIA,
      Agente.GROUP_LIDER_DE_EXPERIENCIA_CENTRAL,
      Agente.GROUP_CONCIERGE,
      Agente.GROUP_AUTOMOTRIZ,
      Agente.GROUP_COBRANZA,
      Agente.GROUP_COBRANZA_NEGOCIO,
      Agente.GROUP_COBRANZA_TDC,
      Agente.GROUP_COBRANZA_CONSUMO,
      Agente.GROUP_COBRANZA_REESTRUCTURAS,
      Agente.GROUP_COBRANZA_AUTO,
      Agente.GROUP_COBRANZA_JURIDICO,
      Agente.GROUP_INMUEBLES,
      Agente.GROUP_TESORERIA,
      Agente.GROUP_AUTO_PF_NORTE,
      Agente.GROUP_AUTO_PF_CENTRO,
      Agente.GROUP_AUTO_PF_OCCIDENTE,
      Agente.GROUP_AUTO_PF_NOROESTE,
      Agente.GROUP_ASESORES_PAGO,
    ];
  };

  static ATTRIBUTE_NAME = "nombre";
  static ATTRIBUTE_LAST_SESSION = "cerroSesion";
  static ATTRIBUTE_CONNECTIONS = "conexiones";
  static ATTRIBUTE_GROUP = "grupo";
  static ATTRIBUTE_EMPLOYEE_ID = "idEmpleado";
  static ATTRIBUTE_PROMOTER_ID = "idPromotor";
  static ATTRIBUTE_IMG = "photoURL";
  static ATTRIBUTE_ROLE = "rol";
  static ATTRIBUTE_EMAIL_REAL = "emailreal";

  /**
   *
   * @returns {(string)[]}
   */
  static GET_ATTRIBUTES = () => {
    return [
      Agente.ATTRIBUTE_NAME,
      Agente.ATTRIBUTE_LAST_SESSION,
      Agente.ATTRIBUTE_CONNECTIONS,
      Agente.ATTRIBUTE_GROUP,
      Agente.ATTRIBUTE_EMPLOYEE_ID,
      Agente.ATTRIBUTE_PROMOTER_ID,
      Agente.ATTRIBUTE_IMG,
      Agente.ATTRIBUTE_ROLE,
      Agente.ATTRIBUTE_EMAIL_REAL,
    ];
  };

  /**
   *
   * @param init
   * @param tenant
   */
  static NEW_INSTANCE_OR_NULL(init, tenant, permissions = []) {
    if (init == null || init === "null" || tenant == null) {
      return null;
    }

    return new Agente(init, tenant, permissions);
  }

  /**
   *
   * @param init
   * @param tenant
   * @constructor
   */
  constructor(init, tenant, permissions = []) {
    if (typeof init === "string") {
      init = JSON.parse(init);
    }

    const usuario = init.usuario;
    if (typeof init === "object") {
      init = JSON.parse(JSON.stringify(init));
    }
    init.usuario = usuario;

    for (const key in init) {
      const val = init[key];
      switch (key) {
        // case Agente.ATTRIBUTE_ROLE:
        //     break;
        // case Agente.ATTRIBUTE_NAME:
        // case Agente.ATTRIBUTE_LAST_SESSION:
        // case Agente.ATTRIBUTE_CONNECTIONS:
        // case Agente.ATTRIBUTE_GROUP:
        // case Agente.ATTRIBUTE_EMPLOYEE_ID:
        // case Agente.ATTRIBUTE_PROMOTER_ID:
        // case Agente.ATTRIBUTE_IMG:
        default:
          break;
      }
      this[key] = val;
    }
    this.tenant = tenant;
    this.permissions = permissions;
  }

  /**
   *
   * @param {(string|string[]|null)} rulesToTest
   * @returns {boolean}
   */
  can(rulesToTest = null) {
    if (rulesToTest == null) {
      return false;
    }
    if (typeof rulesToTest === "string") {
      rulesToTest = [rulesToTest];
    }
    let rules = {};
    let group =
      Agente.ATTRIBUTE_GROUP in this[Agente.USER]
        ? this[Agente.USER][Agente.ATTRIBUTE_GROUP]
        : null;
    if (group != null) {
      rules = Agente.GET_RULES_BY_TENANT_AND_GROUPS(
        this.tenant,
        group,
        this.permissions,
      );
    }
    for (let i = 0; i < rulesToTest.length; i++) {
      const ruleToTest = rulesToTest[i];
      if (!(ruleToTest in rules)) {
        return false;
      }
    }
    return true;
  }

  /**
   *
   * @returns {Object}
   */
  toSimpleObject() {
    return JSON.parse(this.toJson());
  }

  /**
   *
   * @returns {string}
   */
  toJson() {
    return JSON.stringify(this);
  }

  /**
   *
   * @param {string} userTenant
   * @param {string} userGroup
   * @returns {{}}
   */
  static GET_RULES_BY_TENANT_AND_GROUPS = (
    userTenant,
    userGroup,
    permissions = "",
  ) => {
    let rules = {};
    rules[userTenant] = {};
    rules[userTenant][userGroup] = {};
    try {
      permissions.split(",").forEach((perm) => {
        rules[userTenant][userGroup][perm] = perm;
      });
    } catch (error) {}


    // const perms = permissions.split(",");
    // perms.forEach((perm) => {
    //   rules[userTenant][userGroup][perm] = perm;
    // });

    // for (let i = 0; i < tenants.length; i++) {
    //     const tenant = tenants[i];
    //     rules[tenant] = {};

    //     for (let j = 0; j < groups.length; j++) {
    //         const group = groups[j];
    //         rules[tenant][group] = {};

    //         switch (group) {
    //             case Agente.GROUP_LIDER_DE_EXPERIENCIA_CENTRAL:
    //                 rules[tenant][group][Agente.RULE_CAN_TREASSIGN_CONVERSATION] = Agente.RULE_CAN_TREASSIGN_CONVERSATION;
    //                 rules[tenant][group][Agente.RULE_CAN_SEARCH_CONTACT] = Agente.RULE_CAN_SEARCH_CONTACT;
    //                 rules[tenant][group][Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES] = Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES;
    //                 rules[tenant][group][Agente.RULE_CAN_OPEN_BROADCAST] = Agente.RULE_CAN_OPEN_BROADCAST;
    //                 rules[tenant][group][Agente.RULE_CAN_OPEN_DIRECTORY] = Agente.RULE_CAN_OPEN_DIRECTORY;
    //                 break;
    //             case Agente.GROUP_CONCIERGE:
    //                 rules[tenant][group][Agente.RULE_CAN_TREASSIGN_CONVERSATION] = Agente.RULE_CAN_TREASSIGN_CONVERSATION;
    //                 rules[tenant][group][Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES] = Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES;
    //                 break;
    //             case Agente.GROUP_TESORERIA:
    //             case Agente.GROUP_LIDER_DE_EXPERIENCIA:
    //                 rules[tenant][group][Agente.RULE_CAN_SEARCH_CONTACT] = Agente.RULE_CAN_SEARCH_CONTACT;
    //                 rules[tenant][group][Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES] = Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES;
    //                 rules[tenant][group][Agente.RULE_CAN_OPEN_BROADCAST] = Agente.RULE_CAN_OPEN_BROADCAST;
    //                 rules[tenant][group][Agente.RULE_CAN_OPEN_DIRECTORY] = Agente.RULE_CAN_OPEN_DIRECTORY;
    //                 break;
    //             case Agente.GROUP_COBRANZA:
    //             case Agente.GROUP_COBRANZA_NEGOCIO:
    //             case Agente.GROUP_COBRANZA_TDC:
    //             case Agente.GROUP_COBRANZA_CONSUMO:
    //             case Agente.GROUP_COBRANZA_REESTRUCTURAS:
    //             case Agente.GROUP_COBRANZA_AUTO:
    //             case Agente.GROUP_COBRANZA_JURIDICO:
    //                 rules[tenant][group][Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES] = Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES;
    //                 break;
    //             case Agente.GROUP_VENTAS_DIGITALES:
    //             case Agente.GROUP_AUTO_PF_NORTE:
    //             case Agente.GROUP_AUTO_PF_CENTRO:
    //             case Agente.GROUP_AUTO_PF_OCCIDENTE:
    //             case Agente.GROUP_AUTO_PF_NOROESTE:
    //                 if(tenant !== Agente.TENANT_HEY_BANCO) {
    //                     break;
    //                 }
    //                 rules[tenant][group][Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES] = Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES;
    //                 break;
    //             case Agente.GROUP_AUTOMOTRIZ:
    //             case Agente.GROUP_INMUEBLES:
    //                 break;
    //             case Agente.GROUP_ASESORES_PAGO:
    //                 rules[tenant][group][Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES] = Agente.RULE_CAN_SEND_INDIVIDUAL_TEMPLATES;
    //                 rules[tenant][group][Agente.RULE_CAN_TREASSIGN_CONVERSATION] = Agente.RULE_CAN_TREASSIGN_CONVERSATION;
    //                 break;
    //             default:
    //                 break;
    //         }
    //     }
    // }

    if (userTenant != null) {
      rules = userTenant in rules ? rules[userTenant] : {};
    }

    if (userTenant != null && userGroup != null) {
      rules = userGroup in rules ? rules[userGroup] : {};
    }

    return rules;
  };
}
